import React from "react";

const BtnLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="hypnotic" aria-label="Loading"></div>

      <style>{`
        .hypnotic {
          width: 35px;
          height: 35px;
          display: grid;
        }

        .hypnotic::before,
        .hypnotic::after {
          content: "";
          grid-area: 1/1;
          border-radius: 50%;
          background: repeating-radial-gradient(
            farthest-side,
            #0000 0%,
            #f1f1f9 1% 10%,
            #0000 11% 30%
          );
          -webkit-mask: repeating-conic-gradient(#000 0 36deg, #0000 0 72deg);
          animation: hypnotic-animation 2s infinite linear;
        }

        .hypnotic::after {
          -webkit-mask: repeating-conic-gradient(#0000 0 36deg, #000 0 72deg);
          animation-direction: reverse;
        }

        @keyframes hypnotic-animation {
          100% {
            transform: rotate(1turn);
          }
        }
      `}</style>
    </div>
  );
};

export default BtnLoader;
